import { Typography } from '@/components/atoms/Typography/Typography'
import { ContactUsFormModal } from '@/components/organisms/ContactUsFormModal/ContactUsFormModal'
import { DialogModal } from '@/components/organisms/Dialog/Dialog'

interface Props {
  isOpenDialog: boolean
  closeDialog: () => void
}

export function DialogFormContactUsModal ({ isOpenDialog, closeDialog }: Props): JSX.Element {
  return (
    <DialogModal open={isOpenDialog} onOpenChange={closeDialog}>
      <Typography variant='h2' className='mb-2 text-center text-primary'>
        Write us!
      </Typography>
      <ContactUsFormModal />
    </DialogModal>
  )
}
